// Import the functions you need from the SDKs you need
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
import { getMessaging, getToken, onMessage,  } from "firebase/messaging";
import "firebase/messaging";
import { removeUserFirebaseId } from "components/Notification/Notifications";

let messaging;

if (!window.location.href.includes("karsten-portal-b2b-test")) {
  const firebaseConfig = {
    apiKey: "AIzaSyD2qNKXKBogThM5E80KucRfVSE8kyJAC_w",
    authDomain: "portal-pushnotifications.firebaseapp.com",
    projectId: "portal-pushnotifications",
    storageBucket: "portal-pushnotifications.appspot.com",
    messagingSenderId: "997156892547",
    appId: "1:997156892547:web:1b259b70604adfd02250b6",
    measurementId: "G-RN6T9XHVQT",
  };

  // Initialize Firebase
  initializeApp(firebaseConfig);

  messaging = getMessaging();
}

export const getNotificationsPermission = async () => {
  if (window.location.href.includes("karsten-portal-b2b-test")) {
    return new Promise((resolve, reject) => {
      reject();
    });
  }

  const firebaseID = localStorage.getItem("userFirebaseId")

  const removeFirebaseId = () => {
    localStorage.removeItem("userFirebaseId");
    return  removeUserFirebaseId(firebaseID)
  }

  if(firebaseID){
    removeFirebaseId()
  }

  const swRegistration = await navigator.serviceWorker.register('./firebase-messaging-sw.js');
  const getFirebaseToken = await getToken(messaging, {
    serviceWorkerRegistration: swRegistration,
    vapidKey:"BPIXc5zQshSkhb0Eu25c9rOoio3upUijWLylFwjhwMxq4rlMJuSMuqoGZwmAdthI4xHeSt8-dgKzJY85YJt6TPU",
  }).then((res)=>{
    return res
  }).catch((err)=>{
    return err
  });
  return getFirebaseToken
};

export const onMessageListener = (userLoggedIn) => {
  if (
    window.location.href.includes("karsten-portal-b2b-test") ||
    !userLoggedIn
  ) {
    return new Promise((resolve, reject) => {
      reject();
    });
  }

  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("payload", payload);
      resolve(payload);
    });
  });
};
